// node_modules
import { FC, useState, MouseEvent, CSSProperties } from "react";
// Types
import { T2dCoordinate, TTechnology } from "Types";
// Components
import { TechnologyRatesModal } from "./TechnologyRatesModal";
// styles
import styles from './technologyListItemRates.module.scss';
// Components
import { TechnologyRatesSummaryIcon } from "Components";

type TTechnologyListItemRatesProps = {
    technology: TTechnology,
    isOutsideSidebar?: boolean,
}

export const TechnologyListItemRates: FC<TTechnologyListItemRatesProps> = ({technology, isOutsideSidebar}: TTechnologyListItemRatesProps) => {
    // State
    const [isCursorStillOnRatesIcon, setIsCursorStillOnRatesIcon] = useState<boolean>(false);
    const [isCursorStillOnRatesModal, setIsCursorStillOnRatesModal] = useState<boolean>(false);
    const [modalDimensions, setModalDimensions] = useState<T2dCoordinate>({x: 0, y: 0});
    const [ratesIconPosition, setRatesIconPosition] = useState<T2dCoordinate>({x: 0, y: 0});

    // Logic
    const displayTechnologyRatesModal = (mouseEvent: MouseEvent): void => {
        mouseEvent.stopPropagation();
        mouseEvent.preventDefault();
        const targetElement = mouseEvent.currentTarget;
        const rateContainer = targetElement.parentElement;
        const modalContent = rateContainer?.querySelector("div[class^='technologyRatesModal_technologyRatesModal']");
        if(modalContent) {
            setModalDimensions({x: modalContent.getBoundingClientRect().width, y: modalContent.getBoundingClientRect().height});
        }
        setRatesIconPosition({x: mouseEvent.currentTarget.getBoundingClientRect().left, y: mouseEvent.currentTarget.getBoundingClientRect().top});
        setIsCursorStillOnRatesIcon(true);
    };

    const hideTechnologyRatesModal = (mouseEvent: MouseEvent): (() => void) => {
        mouseEvent.stopPropagation();
        mouseEvent.preventDefault();

        const delayDebounceFn = setTimeout(() => {
            setIsCursorStillOnRatesIcon(false);
        }, 100)
        return () => clearTimeout(delayDebounceFn);
    };

    const onMouseLeaveRatesModal = (): void => {
        setIsCursorStillOnRatesModal(false);
        resetPositions();
    };

    const onMouseEnterRatesModal = (): void => {
        setIsCursorStillOnRatesModal(true);
    };

    const getModalStyle = (): CSSProperties => {
        let newModalStyle: CSSProperties = {};

        if (isCursorStillOnRatesIcon || isCursorStillOnRatesModal) {
            // Set left position
            if (isOutsideSidebar && isOutsideSidebar === true) {
                newModalStyle.left = `${ratesIconPosition.x + 46}px`;
            } else {
                newModalStyle.left = `${ratesIconPosition.x + 28}px`;
            }            // Set top position
            if (ratesIconPosition.y + modalDimensions.y - 32 > window.innerHeight - 16) {
                newModalStyle.top = `${window.innerHeight - modalDimensions.y - 16}px`;
            } else {
                newModalStyle.top = `${ratesIconPosition.y -25}px`;
            }
            // Show modal
            newModalStyle.opacity = "1";
            newModalStyle.pointerEvents = "initial";
        }

        return newModalStyle;
    };

    const resetPositions = (): void => {
        setModalDimensions({x: 0, y: 0});
        setRatesIconPosition({x: 0, y: 0});
    };

    return (
        <div className={[styles.rateStar, isOutsideSidebar ? styles.isOutsideSidebar : ""].join(" ")}>
            <div className={styles.rateStartIconContainer}
            onMouseEnter={displayTechnologyRatesModal} 
            onMouseLeave={hideTechnologyRatesModal}>
                <TechnologyRatesSummaryIcon isOutsideSidebar={isOutsideSidebar} technology={technology} noRateNotification={true} />
            </div>
            <div className={styles.technologyRatesModalContainer} style={getModalStyle()}>
                <TechnologyRatesModal
                    handleOnMouseLeaveModal={onMouseLeaveRatesModal} 
                    handleOnMouseEnterModal={onMouseEnterRatesModal} 
                    technology={technology} />
            </div>
        </div> 
    );
};